import React from 'react';
import CartItem from './CartItem';
import './Cart.css';

const Cart = ({ isVisible, hideCart, cart, removeFromCart, updateQuantity, increaseQuantity, decreaseQuantity, quantity}) => {

    return (
        <div className={`cart ${isVisible ? 'open' : ''}`}>
                <div className='cart-container'>
                    <div className='cart-heading'>
                        <h3 className='cart-h3'>Your cart</h3>
                        <a onClick={hideCart}><i class="fa-solid fa-xmark"></i></a>
                    </div>
                    <div className='cart-items'>
                        {/* Render cart items */}
                        {cart.map((item, index) => (
                            <CartItem key={index} {...item} removeFromCart={() => removeFromCart(index)} updateQuantity={updateQuantity} increaseQuantity={increaseQuantity} decreaseQuantity={decreaseQuantity}/>
                        ))}
                    </div>
                </div>
        </div>
    );
}

export default Cart;
